export default __webpack_public_path__ + "static/media/instagram-light.19a3b546.svg";